<div
  class="outline-hero-generation__general"
  [ngClass]="activeTheme"
  [ngStyle]="styles">
    <div class="outline-hero-generation">
      <div class="outline-hero-generation__header">
        <div class="navbar">
          <div>
            <div class="navbar-pages">
              <div class="logo" [ngClass]="showHeaderSection ? 'fade-in' : 'ds-lazy-load'">{{logoTitle || 'Logo'}}</div>
              <ul class="nav-links" *ngIf="!isMobile">
                <li *ngFor="let item of fadeInMenuElements; let i = index"
                    [ngClass]="{'ds-lazy-load': !fadeInMenuElements[i]}">
                  <a [ngClass]="{'fade-in': !!fadeInMenuElements[i]}">{{ menuPages[i]?.page?.title }}</a>
                </li>
              </ul>
            </div>
            <div class="mobile-menu" id="menu" *ngIf="!!isMobile">
              <ul>
                <li>Page 1</li>
                <li>Page 2</li>
                <li>Page 3</li>
                <li>Page 4</li>
                <li>Page 5</li>
                <li>Page 6</li>
              </ul>
            </div>
            <div class="hero-ecommerce">
              <i *ngIf="isEcommerce" class="db-icon db-icon-ds-user"  [ngClass]="{'ds-lazy-load': !showHeaderBg, 'fade-in': showHeaderBg}"></i>
              <i *ngIf="isEcommerce" class="db-icon db-icon-ds-ecommerce-bag"  [ngClass]="{'ds-lazy-load': !showHeaderBg, 'fade-in': showHeaderBg}"></i>
              <i *ngIf="!!isMobile && !openMenu" (click)="!!showHeaderBg && toggleMenu()" class="db-icon db-icon-ds-burger"  [ngClass]="{'ds-lazy-load': !showHeaderBg, 'fade-in': showHeaderBg}"></i>
              <i *ngIf="!!isMobile && !!openMenu" (click)="!!showHeaderBg && toggleMenu()" class="db-icon db-icon-ds-close-sharp"  [ngClass]="{'ds-lazy-load': !showHeaderBg, 'fade-in': showHeaderBg}"></i>
            </div>
            <button class="generate-button"
                    *ngIf="!isMobile && !isEcommerce"
                    [ngClass]="{'ds-lazy-load': !showHeaderBg, 'fade-in': showHeaderBg}">{{generatedTexts?.cta}}</button>
          </div>
        </div>
      </div>
      <div class="outline-hero-generation__content">
        <div>
          <div class="section-main-container">
            <div [ngClass]="fadeInContentElements[0] ? 'fade-in' : 'ds-lazy-load title-section'">
              <h1 class="title" [innerHTML]="generatedTexts?.title"></h1>
            </div>
            <div class="mt20 mb40" [ngClass]="fadeInContentElements[1] ? 'fade-in' : 'ds-lazy-load desc-section'">
              <p class="description" [innerHTML]="generatedTexts?.description"></p>
            </div>
            <button class="generate-button"
                    [ngClass]="fadeInContentElements[2] ? 'fade-in' : 'ds-lazy-load'">
              <span>{{generatedTexts?.cta}}</span>
            </button>
          </div>
          <img class="mt64" [src]="(generationFinished ? 'data:image/jpg;base64,' : '') + generatedTexts?.image" alt="" *ngIf="!!isMobile" [ngClass]="{'ds-lazy-load': showBgImage}"/>
          <div class="section-image-container"
               *ngIf="!isMobile"
               [ngClass]="{'ds-lazy-load': showBgImage}"
               [ngStyle]="{backgroundImage: 'url(&quot;'+ (generationFinished ? 'data:image/jpg;base64,' : '') + generatedTexts?.image + '&quot;)'}"
          ></div>
        </div>
      </div>
  </div>
</div>


<!--<div class="container">
  <div class="text-section">
    <h1>Create stunning photos with AI mastery</h1>
    <p>Whether you're a professional photographer or creative enthusiast, our tools help you break boundaries and bring your imagination to life.</p>
    <button class="button">Generate Your Website</button>
  </div>
  <div class="image-section">
    <img src="image.png" alt="AI Generated Photography">
  </div>
</div>-->
